module.exports = __webpack_public_path__ + "img/arrow-up-down.8d8f58fd.svg";